import { Link, LinkProps } from 'react-router-dom';
import { addUtmParamsToUrl, getUtmParams } from '@/lib/utils';

/**
 * Custom Link component that preserves UTM parameters in the URL
 * Use this instead of React Router's Link component for all public-facing links
 */
export function UTMLink({ to, children, ...props }: LinkProps) {
  // Get UTM parameters from current URL
  const utmParams = getUtmParams();
  
  // If there are no UTM parameters, just use the regular Link
  if (Object.keys(utmParams).length === 0) {
    return <Link to={to} {...props}>{children}</Link>;
  }
  
  // Handle different types of 'to' prop
  let enhancedTo;
  
  if (typeof to === 'string') {
    // For string destinations
    enhancedTo = addUtmParamsToUrl(to);
  } else {
    // For object destinations
    const searchParams = new URLSearchParams(to.search || '');
    
    // Add each UTM parameter
    Object.entries(utmParams).forEach(([key, value]) => {
      searchParams.set(key, decodeURIComponent(value));
    });
    
    enhancedTo = {
      ...to,
      search: searchParams.toString()
    };
  }

  return (
    <Link to={enhancedTo} {...props}>
      {children}
    </Link>
  );
}